// YesNoRadioGroup.js
import styles from "./Prizes.module.css";
import React, { useState } from 'react';
import RadioButton from './RadioButton';

const PrizesRadioGroup = () => {
  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div>
      <RadioButton
        name="prizesYesNoGroup"
        value="Yes"
        checked={selectedValue}
        onChange={handleChange}
      />
      <RadioButton
        name="prizesYesNoGroup"
        value="No"
        checked={selectedValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default PrizesRadioGroup;



